module.exports = __webpack_public_path__ + "img/cns_printer_mac33.be58cb9b.png";